///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespace
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.promos = abcsetup.promos || {};
abcsetup.promos.form_manager = abcsetup.promos.form_manager || {};




///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Variables
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.promos.form_manager.form = null;




///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.promos.form_manager = {

    /**
     * Loop through the current global abcsetup.item and set form fields values
     * (Create hidden fields for items that don't exist)
     * Note this is separate from the default setFormItems function located in the _form_manager.js file
     * because the promo item form contains some extra fields that are just display fields and are in child objects
     * i.e. the ABCItem data that needs to be displayed for the item
     * FIXME : Should be moved into the _form_manager.js file with improvements to accommodate other entity form types.
     */
    setFormItems : function(viewOnly = false){
        // Update the form fields
        for (var i in abcsetup.item) {
            if (abcsetup.item[i] !== null) {
                //console.log(i + ' :: ' + $.type(abcsetup.item[i]));
                this._setFieldValue(i, abcsetup.item[i],viewOnly);
            }
        };

        // Set up the fields to view-only
        if (viewOnly) {
            abcsetup.promos.form_manager.form.find(':input').each(function() {
                if ($(this).hasClass('btn') && !$(this).attr('data-fieldname') ) {
                    return;
                }
                // if (!$(this).hasClass('hide') && $(this).attr('type') != 'hidden') {
                 if (!$(this).hasClass('hide') && ($(this).attr('type')) != 'hidden') {
                    var field_id = $(this).attr('id') ? 'id="'+$(this).attr('id')+'"' : '';
                    if ($(this).prop('nodeName') == 'SELECT') {
                        $(this).attr('disabled', true).addClass('view-only').attr('title', '');
                    }
                    else if ($(this).prop('nodeName') == 'TEXTAREA') {
                        $(this).replaceWith('<textarea ' + field_id + ' class="form-control view-only" readonly>'+ $(this).val() +'</textarea>');
                    }
                    else if ($(this).is(':checkbox')) {
                        // we don't want the actual value of the checkbox to be displayed as text, hence, replace as a hidden input
                        $(this).replaceWith('<input type="hidden" ' + field_id + ' class="form-control view-only" value="' + $(this).val() + '" readonly>');
                    }
                    else {
                        $(this).replaceWith('<input type="text" ' + field_id + ' class="form-control view-only" value="' + $(this).val() + '" readonly>');
                    }
                }
            });
        }
    },

    /**
     * Find and set the value of a form field
     *
     * @param {*} name
     * @param {*} value
     */
    _setFieldValue: function(name, value,viewOnly) {
        if ($.type(value) != 'object') {
            // The current value is not an array
            if ($.type(value) != 'array') {
                var field = abcsetup.promos.form_manager.form.find(':input[name="' + name + '"]');
                // The field is a date field
                if (field.attr('type') == 'date') {
                    field.val(moment(value, 'YYYY-MM-DD').format('YYYY-MM-DD'));
                } else {
                    field.val(value);
                }
            } else if (name == 'promo_attr'){
                $.each(value, function (index, promo_attr) {
                    // promo_attributes[promo_attr.attr] = promo_attr.val;
                    var field = abcsetup.promos.form_manager.form.find(':input[name="' + promo_attr.attr + '"]');
                    if (field.attr('type') == 'date') {
                        field.val(moment(promo_attr.val, 'YYYY-MM-DD').format('YYYY-MM-DD'));
                    } else if (promo_attr.attr == 'competitive_product_upcs') {
                        field = abcsetup.promos.form_manager.form.find(':input[id="competitive_product_upcs_0"]');
                        console.log("!!competitive_product_upcs!!",field);
                        var values = promo_attr.val.split(',');
                        var count = 0;
                        // render all the upc fields with their values
                        for (idx in values) {
                            if (idx == 0) {
                                // Set the first value as normal
                                field.val(values[idx]);
                                continue;
                            }
                            count++;
                            var field_row = field.closest('.form-group.row').clone();
                            field_row.removeAttr('requiredIf');
                            field_row.removeAttr('required').removeClass('required');
                            field_row.find('label').attr('for','competitive_product_upcs_'+count).html('--- '+(count+1)+' ---');
                            field_row.find('input').attr('id','competitive_product_upcs_'+count).val(values[idx]).removeAttr('required');
                            $('#competitive_product_upcs_'+(count-1)).closest('.form-group.row').after(field_row);
                        }
                        // Add an extra field at the end
                        if (promo_attr.val != '' && count<19 && !viewOnly){
                            count++
                            // We only allow up to 20 UPCS
                            var field_row = field.closest('.form-group.row').clone();
                            field_row.removeAttr('requiredIf');
                            field_row.removeAttr('required').removeClass('required');
                            field_row.find('label').attr('for','competitive_product_upcs_'+count).html('--- '+(count+1)+' ---');
                            field_row.find('input').attr('id','competitive_product_upcs_'+count).val('').removeAttr('required');
                            $('#competitive_product_upcs_'+(count-1)).closest('.form-group.row').after(field_row);
                        }
                    } else if (promo_attr.attr == 'type_of_customer') {
                        let select_right =  abcsetup.promos.form_manager.form.find(':input[name="' + promo_attr.attr + '[]"]');
                        let this_shuttlebox = select_right.closest("div.shuttlebox");
                        let select_left = this_shuttlebox.find("select.shuttlebox-left");
                        let sel_val = promo_attr.val.split(',');
                        $.each(sel_val, function( index, value ) {
                            if (value != '') {
                                select_right.append(select_left.find("option[value="+value+"]").prop('selected','selected'));
                                select_left.find("option[value="+value+"]").remove();
                            }
                        });
                    } else {
                        field.val(promo_attr.val);
                    }
                    // field.val(promo_attr.val);
                });
            }
        } else if (name == 'a_b_c_item') {
            $.each( value, function(field_name, field_value) {
                if (field_name == 'pricing') {
                    $.each( field_value, function(price_field_name, price_field_value) {
                        var field = abcsetup.promos.form_manager.form.find(':input[name="' + price_field_name + '"]');
                        field.val(price_field_value);
                    });
                }
                var field = abcsetup.promos.form_manager.form.find(':input[name="' + field_name + '"]');
                field.val(field_value);
            });
        } else if (name == 'promo_item_status') {
            var field = abcsetup.promos.form_manager.form.find(':input[name="item_status_name"]');
            field.val(value.name);
        }

        // Refresh the shuttlebox
        if ( abcsetup.promos.form_manager.form.find(':input[name="' + name + '[]"]').hasClass('shuttlebox-right')) {
            var select_right =  abcsetup.promos.form_manager.form.find(':input[name="' + name + '[]"]');
            var this_shuttlebox = select_right.closest("div.shuttlebox");
            var select_left = this_shuttlebox.find("select.shuttlebox-left");
            var sel_val = value;
            $.each(sel_val, function( index, value ) {
                if (value != '') {
                    select_right.append(select_left.find("option[value="+value+"]").prop('selected','selected'));
                    select_left.find("option[value="+value+"]").remove();
                }
            });
        }
    },
}